import PropTypes from 'prop-types';
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import User from '~/modules/common/components/User';

const useStyles = makeStyles(theme => ({
  name: {
    paddingTop: 0,
    paddingBottom: 0,
    fontSize: theme.typography.body2.fontSize,
    whiteSpace: 'break-spaces'
  }
}));

export const UserFormatter = ({ field, record }) => {
  const classes = useStyles();
  const user = record[field];

  return user?.displayText ? <User user={user} classes={classes} /> : '';
};
UserFormatter.propTypes = {
  record: PropTypes.object.isRequired,
  field: PropTypes.string.isRequired
};

export default UserFormatter;
